const progressBarMax = 100
const scoredAttributeMax = 5

export const normalizeScore = (value: number) =>
  value ? value * (progressBarMax / scoredAttributeMax) : 0
